import Loadable from "../../../components/Loadable";

const DaftarKuesioner = Loadable(() => import("./DaftarKuesioner"));
const DetilKuesioner = Loadable(() => import("./DetilKuesioner"));

export default {
  DetilKuesioner,
  DaftarKuesioner,
};
